import { useState } from "react";
import { Box, Grid, IconButton } from "@mui/material";
import { VpnKey } from "@mui/icons-material";
import { t } from "i18next";
import CustomModal from "../../../../../../components/Modal";
import SelfManaged from "./selfManaged";
import SystemManaged from "./systemManaged";

function KeyManagement({ domain }) {
  const [modalOpen, setModalOpen] = useState(false);
  const handleClose = () => {
    setModalOpen(false);
  };

  const handleOpen = () => {
    setModalOpen(true);
  };

  return (
    <>
      <IconButton onClick={handleOpen}>
        <VpnKey />
      </IconButton>

      {domain &&
        <CustomModal
          open={modalOpen}
          handleClose={handleClose}
          title={t("domain.certificate_management")}
        >
          <Box py={2} px={{ md: 5, xs: 0 }}>
            <Grid container spacing={2} rowSpacing={3} sx={{ mt: 1 }}
                  className="flex-column-md" justifyContent="center"
            >

              {domain.certmanaged === "0" ?
                <SelfManaged domain={domain} handleClose={handleClose} />
                :
                <SystemManaged domain={domain} />
              }

            </Grid>
          </Box>
        </CustomModal>
      }
    </>
  )
}

export default KeyManagement;
